import React from 'react';
import './GrowYourBussion.css';
import user from '../../assets/images/user-dil.svg';
import bag from '../../assets/images/badge-check.svg';
import shield from '../../assets/images/shield-check.svg';
import smile from '../../assets/images/smile.svg';
import img from '../../assets/images/cre-32.png';

const GrowYourBussion = () => {
	return (
		<div className="GrowYourBussionWrapper">
			<div className="container">
				<div className="GrowYourBussion-wrapper ">
					<div className="top-wrapper flex gap-30 justify-center">
						<div className="left">
							<img src={img} alt="mobile" />
						</div>
						<div className="right">
						
							<h2 className="heading-2 fs-sm-20">
								Grow Your Business With <span className="strong">Pay2Mobiles!</span>
							</h2>
							<p className="h3">Secure and reliable Services Provided by Pay2Mobile is India's best leading online service provider.</p>

							<p className='fs-sm-12'>
								We at Pay2Mobile deliver Recharge( Mobile, Dth, Data Card), and Bill Payment System( Electricity,
								Landline, Mobile Bill Payment) of all leading service providers at the unbelievably lowest price. Now you don’t have to stand in queue for all Recharge, Bill Payment You Can pay easily all these payments with Pay2Mobile store services in India. You can transfer money from any place to any bank account at any
								time in India using Pay2Mobile Store domestic money transfer service.
							</p>
						</div>
					</div>

					<div className="middle-wrapper">
						<h2 className="heading-2 text-center fs-sm-20">
							Get To Know <span className="strong">Pay2Mobiles!</span>
						</h2>
						<div className="center">
							<div className="box">
								<div className="img center">
									<img src={bag} alt="shield" />
								</div>
								<h2 className='fs-sm-20'>100%</h2>
								<p className='fs-sm-12'>Success Transaction</p>
							</div>
							<div className="box">
								<div className="img center">
									<img src={user} alt="user" />
								</div>
								<h2 className='fs-sm-20'>700+</h2>
								<p className='fs-sm-12'>Total Retailers</p>
							</div>
							<div className="box">
								<div className="img center">
									<img src={shield} alt="shield" />
								</div>
								<h2 className='fs-sm-20'>100%</h2>
								<p className='fs-sm-12'>Secure Payment</p>
							</div>
							<div className="box box-4">
								<div className="img center">
									<img src={smile} alt="smile" />
								</div>
								<h2 className='fs-sm-20'>2K</h2>
								<p className='fs-sm-12'>Happy Customers</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GrowYourBussion;
